import { Routes } from "@angular/router";
import { CwtAuthGuard } from "@cawita/core-front/auth";

export default [
    { path: 'auth', loadChildren: () => import('./auth/auth.routes') },
    { path: '', canActivate: [CwtAuthGuard({ accessTypes: 'user' })], loadChildren: () => import('./main/main.routes') }
] as Routes;